import React, { useMemo, useState } from "react";
import {
  Box,
  Dialog,
  DialogContent,
  FormControl,
  IconButton,
  MenuItem,
  Pagination,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const pink = "#f43f6b";

const rows = [
  {
    "model": "GT06",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "EV02",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "V7",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "V5",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "GS03",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "vt08s",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "WETRACK",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "MT02",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5015,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "Et300",
    "apkCommand": "#6666#sapn#airteliot.com#####",
    "ipCommand": "#6666#IP#69.62.73.45#5023#",
    "timezoneCommand": "#6666#stz#e0#"
  },
  {
    "model": "BW09",
    "apkCommand": "#6666#sapn#airteliot.com#####",
    "ipCommand": "#6666#IP#69.62.73.45#5023#",
    "timezoneCommand": "#6666#stz#e0#"
  },
  {
    "model": "RP01",
    "apkCommand": "#6666#sapn#airteliot.com#####",
    "ipCommand": "#6666#IP#69.62.73.45#5023#",
    "timezoneCommand": "#6666#stz#e0#"
  },
  {
    "model": "TR08A",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,2019,69.62.73.45,5105,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "LT05",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,2019,69.62.73.45,5105,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "AT06N",
    "apkCommand": "Apn,123456,airteliot.com",
    "ipCommand": "Ip,123456,69.62.73.45,5023",
    "timezoneCommand": "timezone,123456,0,00"
  },
  {
    "model": "LT08A",
    "apkCommand": "Apn,123456,airteliot.com",
    "ipCommand": "Ip,123456,69.62.73.45,5023",
    "timezoneCommand": "timezone,123456,0,00"
  },
  {
    "model": "Coban",
    "apkCommand": "Apn123456 airteliot.com",
    "ipCommand": "Adminip123456 69.62.73.45 7012",
    "timezoneCommand": "Time zone123456 0.00"
  },
  {
    "model": "ST901",
    "apkCommand": "8030000 airteliot.com",
    "ipCommand": "8040000 69.62.73.45 5013",
    "timezoneCommand": "8090000 10"
  },
  {
    "model": "iTracksafe",
    "apkCommand": "8030000 airteliot.com",
    "ipCommand": "8040000 69.62.73.45 5013",
    "timezoneCommand": "8090000 10"
  },
  {
    "model": "T8803+",
    "apkCommand": "APN,0000,AIRTELIOT.COM#",
    "ipCommand": "IP,0000,69.62.73.45,5094#",
    "timezoneCommand": "GMT,0000,0.0#"
  },
  {
    "model": "GT05",
    "apkCommand": "Apn123456 airteliot.com",
    "ipCommand": "Adminip123456 69.62.73.45 5013",
    "timezoneCommand": "Time zone123456 0.00"
  },
  {
    "model": "FMB920",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "FMB910",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "FMB120",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "FMB125",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "MT100",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,0,69.62.73.45,5023,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "GT300",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,0,69.62.73.45,5023,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "G20",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,0,69.62.73.45,5023,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "JV200",
    "apkCommand": "Apn,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TK003",
    "apkCommand": "apn,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "S102",
    "apkCommand": "apn,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "X-1",
    "apkCommand": "Apn,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "CNC9TE",
    "apkCommand": "Apn,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "Siwi",
    "apkCommand": "",
    "ipCommand": "ttysms,NIP=69.62.73.45;NPT=5135;APN=airteliot.com;REBOOT",
    "timezoneCommand": "tzn=<+/-00:00>"
  },
  {
    "model": "FMB130",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "BD101",
    "apkCommand": "#* 1234 APNC \"airteliot.com\"#",
    "ipCommand": "#* 1234 SERVER \"69.62.73.45\"05070#",
    "timezoneCommand": ""
  },
  {
    "model": "R11",
    "apkCommand": "SERVER,0,69.62.73.45,5023,0#",
    "ipCommand": "APN,AIRTELIOT.COM#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "VT05S",
    "apkCommand": "Server,0,69.62.73.45,5023,0#",
    "ipCommand": "Apn,airteliot.com#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "VG03",
    "apkCommand": "SERVER,0,69.62.73.45,5023,0#",
    "ipCommand": "APN,AIRTELIOT.COM#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "R11",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "LT05+",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "CJ720",
    "apkCommand": "apn123456",
    "ipCommand": "Adminip123456 69.62.73.45 5013",
    "timezoneCommand": "timezone123456 0"
  },
  {
    "model": "G19",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "G18",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "WETRACK2",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GT23",
    "apkCommand": "",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": ""
  },
  {
    "model": "MV720",
    "apkCommand": "",
    "ipCommand": "adminip123456 69.62.73.45 5013",
    "timezoneCommand": ""
  },
  {
    "model": "S20",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "PT20",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TR06",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TK100",
    "apkCommand": "",
    "ipCommand": "#IP#123456#69.62.73.45#5023#",
    "timezoneCommand": ""
  },
  {
    "model": "LT05+",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,2018,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "Gosafe G3A",
    "apkCommand": "8899,SVR;69.62.73.45;5078;;0;0",
    "ipCommand": "",
    "timezoneCommand": ""
  },
  {
    "model": "G18",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "HB- A5",
    "apkCommand": "#000000,STAP:CMNET",
    "ipCommand": "#000000,STIP:69.62.73.45,5015",
    "timezoneCommand": "#000000,STTZ:+0"
  },
  {
    "model": "Atelematics",
    "apkCommand": "AS1234*269#3,airteliot.com,,,#",
    "ipCommand": "AS1234*269#1,69.62.73.45,5058,0#",
    "timezoneCommand": "AS1234TIME:0#"
  },
  {
    "model": "ET301",
    "apkCommand": "apn,airteliot.com#",
    "ipCommand": "ip,69.62.73.45,5064#",
    "timezoneCommand": "gmt,e,0,0#"
  },
  {
    "model": "AOT",
    "apkCommand": "",
    "ipCommand": "#ip#123456#69.62.73.45#5246#",
    "timezoneCommand": ""
  },
  {
    "model": "GOSAFE G1C",
    "apkCommand": "",
    "ipCommand": "<SPGS*P:GSGPS*T:69.62.73.45:5015>",
    "timezoneCommand": ""
  },
  {
    "model": "BW08",
    "apkCommand": "#6666#sapn#airteliot.com#####",
    "ipCommand": "#6666#IP#69.62.73.45#5023#",
    "timezoneCommand": "#6666#stz#e0#"
  },
  {
    "model": "GT06N",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "x3",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "Gosafe G3A",
    "apkCommand": "",
    "ipCommand": "8899,SVR;69.62.73.45;5078;;0;0",
    "timezoneCommand": ""
  },
  {
    "model": "VT05S",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "VG03",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "R11",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "VG42",
    "apkCommand": "APN123456 safaricom",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": "TIMEZONE123456 0"
  },
  {
    "model": "S15",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "AT01",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "RP02",
    "apkCommand": "Apn,123456,airteliot.com",
    "ipCommand": "Ip,123456,69.62.73.45,5023",
    "timezoneCommand": "Timezone,123456,0"
  },
  {
    "model": "PS03",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "LT02",
    "apkCommand": "",
    "ipCommand": "111111WWW:IPN:69.62.73.45;COM:5023;",
    "timezoneCommand": ""
  },
  {
    "model": "Gosafe G3A",
    "apkCommand": "",
    "ipCommand": "8899,SVR;69.62.73.45;5078;;0;0",
    "timezoneCommand": ""
  },
  {
    "model": "jt808",
    "apkCommand": "*SPJLX*P:753869*A:APN,airteliot.com, ,#",
    "ipCommand": "*SPJLX*P:753869*U:69.62.73.45,5015,1,#",
    "timezoneCommand": ""
  },
  {
    "model": "GT06N ( magent device) (M60)",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "GMNET,69.62.73.45,5023,#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TV101S-2G",
    "apkCommand": "*SPJLX*P:753869*A:APN,airteliot.com, ,#",
    "ipCommand": "*SPJLX*P:753869*U:69.62.73.45,5015,1,#",
    "timezoneCommand": "*SPJLX*P:753869*TM:+0000#"
  },
  {
    "model": "TV101S-2G5",
    "apkCommand": "*SPJLX*P:753869*A:APN,airteliot.com, ,#,5",
    "ipCommand": "*SPJLX*P:753869*U:69.62.73.45,5015,1,#,5",
    "timezoneCommand": "*SPJLX*P:753869*TM:+0000#,5"
  },
  {
    "model": "TV101S-2G",
    "apkCommand": "*SPJLX*P:753869*A:APN,airteliot.com, ,#",
    "ipCommand": "*SPJLX*P:753869*U:69.62.73.45,5015,1,#",
    "timezoneCommand": "*SPJLX*P:753869*TM:+0000#"
  },
  {
    "model": "OBD G500M",
    "apkCommand": "APN,airteliot.com",
    "ipCommand": "IP,69.62.73.45,5064,0#",
    "timezoneCommand": "GMT,E,5,60#"
  },
  {
    "model": "gagan navic Ais-140",
    "apkCommand": "rpointais,SET SIP:69.62.73.45,SPT:5179",
    "ipCommand": "rpointais,SET SIP:69.62.73.45,SPT:5179",
    "timezoneCommand": "rpointais,SET SIP:69.62.73.45,SPT:5179"
  },
  {
    "model": "AA2",
    "apkCommand": "Apn123456 airteliot.com",
    "ipCommand": "Adminip123456 69.62.73.45 5013",
    "timezoneCommand": "Time zone123456 0.00"
  },
  {
    "model": "GF20",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "IP,69.62.73.45,5013,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GF20",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "IP,69.62.73.45,5013,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "FMC130",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "Lynkworld 2g-4c",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "BALAJI BD312",
    "apkCommand": "#* 1234 SERVER \"69.62.73.45\"05132#",
    "ipCommand": "#* 1234 SERVER \"69.62.73.45\"05132#",
    "timezoneCommand": "#* 1234 SERVER \"69.62.73.45\"05132#"
  },
  {
    "model": "M60- GT06N ( magent device)",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "GMNET,69.62.73.45,5023,#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GT06(5023)",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "tk61-wireless",
    "apkCommand": "IP 69.62.73.45 5013",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": "IP 69.62.73.45 5013"
  },
  {
    "model": "tk61-wireless",
    "apkCommand": "APN123456 safaricom",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": "IP 69.62.73.45 5013"
  },
  {
    "model": "NVT-1920 AIS(5179)",
    "apkCommand": "",
    "ipCommand": "SETTS fleet.nipponsecura.in:5179",
    "timezoneCommand": ""
  },
  {
    "model": "tk61-wireless",
    "apkCommand": "IP 69.62.73.45 5013",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": "IP 69.62.73.45 5013"
  },
  {
    "model": "tk61-wireless",
    "apkCommand": "IP 69.62.73.45 5013",
    "ipCommand": "IP 69.62.73.45 5013",
    "timezoneCommand": "IP 69.62.73.45 5013"
  },
  {
    "model": "FIFO S20",
    "apkCommand": "",
    "ipCommand": "B00,1, 69.62.73.45,5124",
    "timezoneCommand": ""
  },
  {
    "model": "Cncote",
    "apkCommand": "",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "LT03",
    "apkCommand": "",
    "ipCommand": "111111WWW:IPN:69.62.73.45;COM:5009;",
    "timezoneCommand": ""
  },
  {
    "model": "tramigo/T23",
    "apkCommand": "gprs,apn,internet",
    "ipCommand": "gprs,connect,69.62.73.45,5073,tcp",
    "timezoneCommand": ""
  },
  {
    "model": "TK303",
    "apkCommand": "",
    "ipCommand": "Adminip123456 69.62.73.45 7012",
    "timezoneCommand": "Time zone123456 0.00"
  },
  {
    "model": "LC100(atlanta)",
    "apkCommand": "#CONFIG::AIRTELIOT.COM::::;<6906>",
    "ipCommand": "#serverchange::69.62.73.45::5023;<6906>",
    "timezoneCommand": ""
  },
  {
    "model": "W15",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "FMC130",
    "apkCommand": "setparam 2001:airteliot.com",
    "ipCommand": "setparam 2004:69.62.73.45",
    "timezoneCommand": "setparam 2005:5027"
  },
  {
    "model": "G19 (Wanway)",
    "apkCommand": "APN,airteliot.com",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GT02",
    "apkCommand": "",
    "ipCommand": "SERVER,69.62.73.45.205,5023,0#",
    "timezoneCommand": "GMT,666666,e,0,00#"
  },
  {
    "model": "ATLANTA AIS 140",
    "apkCommand": "#CONFIG::AIRTELIOT.COM::::;<6906>",
    "ipCommand": "#SERVERCHANGE:69.62.73.45::5179;<6906>",
    "timezoneCommand": ""
  },
  {
    "model": "ZS AIS 140",
    "apkCommand": "",
    "ipCommand": "#SERVERCHANGE:69.62.73.45::5179;&lt;6906&gt;",
    "timezoneCommand": ""
  },
  {
    "model": "G17",
    "apkCommand": "APN,airteliot.com",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TK106",
    "apkCommand": "#apn#123456#airtiot.com#",
    "ipCommand": "#ip#123456#69.62.73.45#5023#",
    "timezoneCommand": "#timezone#123456#W#0#0#0#"
  },
  {
    "model": "TK103",
    "apkCommand": "",
    "ipCommand": "IP69.62.73.45PORT5023",
    "timezoneCommand": "ZONE123456 0.00"
  },
  {
    "model": "AROTRACK AIS140",
    "apkCommand": "",
    "ipCommand": "SET CUPS:69.62.73.45-5179-TCP",
    "timezoneCommand": ""
  },
  {
    "model": "TS101",
    "apkCommand": "set$add device number@aquila123#CFG_GPRS:airtelgprs.com,,,69.62.73.45,5179",
    "ipCommand": "",
    "timezoneCommand": ""
  },
  {
    "model": "LT05",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,2019,69.62.73.45,5023,0;",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TK103",
    "apkCommand": "APN123456 AIRTELGPRS.COM",
    "ipCommand": "IP69.62.73.45PORT5002",
    "timezoneCommand": "ZONE123456 0.00"
  },
  {
    "model": "FM-Eco4 RUPTELA",
    "apkCommand": "setconnection internet.be,,,TCP,128.199.21,5046,*old*,*old*,*old*,",
    "ipCommand": "",
    "timezoneCommand": ""
  },
  {
    "model": "I'd traker",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "I'd traker",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "I'd traker",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "I'd traker",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "ID CARD TRAKER",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TFB303",
    "apkCommand": "AS9876*269#3,AIRTELIOT.COM,,,#",
    "ipCommand": "AS9876*269#1,69.62.73.45,5058,1#",
    "timezoneCommand": "AS1234TIME:+0#"
  },
  {
    "model": "M04",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "GMNET,69.62.73.45,5023#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "BHARAT 101 AIS 140",
    "apkCommand": "",
    "ipCommand": "SETIP3 69.62.73.45*SETPORT3 5179",
    "timezoneCommand": ""
  },
  {
    "model": "wheels ais140",
    "apkCommand": "",
    "ipCommand": "PASS#EDS,@SET#IP3-69.62.73.45,PORT3-5179",
    "timezoneCommand": ""
  },
  {
    "model": "Transync AIS140",
    "apkCommand": "VLTSETTT#0000;PASS#0000;IP#69.62.73.45;PORT#5248",
    "ipCommand": "VLT;0000;STATUS",
    "timezoneCommand": ""
  },
  {
    "model": "ET06",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "WETRAK AIS 140",
    "apkCommand": "",
    "ipCommand": "SERVER,0,69.62.73.45,5179,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GS05",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "GMNET,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "Atlanta E101",
    "apkCommand": "#CONFIG::AIRTELIOT.COM::::;<6906>",
    "ipCommand": "#serverchange::69.62.73.45::5112;<6906>",
    "timezoneCommand": ""
  },
  {
    "model": "FT112 A02 Gl",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,128,199,21,17,5023#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "GT02A",
    "apkCommand": "APN,666666,airteliot.com#",
    "ipCommand": "server,666666,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,666666,E,0,00#"
  },
  {
    "model": "G1C",
    "apkCommand": "",
    "ipCommand": "<SPGS*P:GSGPS*T:69.62.73.45,5015>",
    "timezoneCommand": ""
  },
  {
    "model": "MT200",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "UTC,00#"
  },
  {
    "model": "3 GB Technology AIS 140",
    "apkCommand": "APN:taisysnet:bsnlnet",
    "ipCommand": "sip:69.62.73.45,spt:5179",
    "timezoneCommand": ""
  },
  {
    "model": "PT20 Magnet",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "R56 OBD",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,8520,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "BR05",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "BR05",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5023#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "id tracker",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER#69.62.73.45#5199#",
    "timezoneCommand": "com.track.itrack"
  },
  {
    "model": "ID TRACKER G10",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "IP#69.62.73.45#5023#",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "LKGPS",
    "apkCommand": "Apn123456 airteliot.com",
    "ipCommand": "Adminip123456 69.62.73.45 5013",
    "timezoneCommand": "timezone123456 0"
  },
  {
    "model": "R12",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "MT150",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "Server,0,69.62.73.45,5023,0;",
    "timezoneCommand": "GMT,E,0,0#"
  },
  {
    "model": "PSDN100 AIS140",
    "apkCommand": "",
    "ipCommand": "rpointais,SET SIP:69.62.73.45,SPT:5179",
    "timezoneCommand": ""
  },
  {
    "model": "RDM AIS 140",
    "apkCommand": "",
    "ipCommand": "SETIP2 69.62.73.45*SETPORT2 5179",
    "timezoneCommand": ""
  },
  {
    "model": "G60",
    "apkCommand": "APN,AIRTELIOT.COM#",
    "ipCommand": "SERVER,0,69.62.73.45,5023,0#",
    "timezoneCommand": "GMT,0,0#"
  },
  {
    "model": "JT808 normal",
    "apkCommand": "SL APNAIRTELIOT.COM,,",
    "ipCommand": "SL DP69.62.73.45#5015#",
    "timezoneCommand": "SL INTV10,200"
  },
  {
    "model": "JT808_Dashcam",
    "apkCommand": "<SPBSJ*P:BSJGPS*p:bsjkj*A:AIRTELIOT.COM>",
    "ipCommand": "<SPBSJ*P:BSJGPS*T:69.62.73.45,5015>",
    "timezoneCommand": "<SPBSJ*P:BSJGPS*9E:8:0>"
  },
  {
    "model": "XYZ PICTOR",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "SERVER,0,69.62.73.45,5033,0#",
    "timezoneCommand": "GMT,E,0,00#"
  },
  {
    "model": "TNAVIC140",
    "apkCommand": "APN,airteliot.com#",
    "ipCommand": "rpointais,SET SIP:69.62.73.45,SPT:5179",
    "timezoneCommand": "GMT,E,0,0#"
  }
];

const tableCellSx = {
  borderBottom: "0",
  py: 1.2,
  fontSize: 13,
  color: "#252525",
  whiteSpace: "nowrap",
};

export default function DeviceModelModal({ open = true, onClose }) {
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);

  const filteredRows = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) return rows;
    return rows.filter((row) =>
      Object.values(row).some((value) => String(value).toLowerCase().includes(query))
    );
  }, [search]);

  const totalRows = filteredRows.length;
  const totalPages = Math.max(1, Math.ceil(totalRows / rowsPerPage));
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const visibleRows = filteredRows.slice(startIndex, endIndex);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "calc(100vw - 56px)",
          maxWidth: "1120px",
          height: "auto",
          maxHeight: "calc(100vh - 72px)",
          borderRadius: 0,
          m: 0,
          overflow: "hidden",
          bgcolor: "#fff",
          boxShadow: "0 16px 40px rgba(0,0,0,0.22)",
        },
      }}
    >
      <DialogContent sx={{ p: 0, height: "100%", display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            height: 56,
            px: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid #e5e7eb",
          }}
        >
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#202124" }}>Device Model</Typography>
          <IconButton onClick={onClose} sx={{ color: "#111", p: 0.5 }}>
            <CloseIcon sx={{ fontSize: 24 }} />
          </IconButton>
        </Box>

        <Box sx={{ bgcolor: "#f8f9fb", p: 1.5, pb: 1.5, flex: 1, minHeight: 0 }}>
          <Box sx={{ bgcolor: "#fff", boxShadow: "0 1px 10px rgba(0,0,0,0.03)" }}>
            <Box sx={{ height: 56, display: "flex", alignItems: "center", px: 1 }}>
              <TextField
                value={search}
                onChange={(event) => {
                  setSearch(event.target.value);
                  setPage(1);
                }}
                placeholder="Search"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  endAdornment: <SearchIcon sx={{ color: pink, fontSize: 21 }} />,
                }}
                sx={{
                  width: 205,
                  bgcolor: "#fff",
                  px: 1.6,
                  py: 1,
                  "& input": {
                    fontSize: 13,
                    color: "#111",
                    fontWeight: 500,
                  },
                  "& input::placeholder": {
                    opacity: 1,
                    color: "#111",
                  },
                }}
              />
            </Box>

            <Box
              sx={{
                height: 64,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 1.5,
                borderBottom: "1px solid #8c8c8c",
              }}
            >
              <FormControl size="small">
                <Select
                  value={rowsPerPage}
                  onChange={(event) => {
                    setRowsPerPage(Number(event.target.value));
                    setPage(1);
                  }}
                  sx={{
                    width: 71,
                    height: 31,
                    fontSize: 13,
                    borderRadius: "4px",
                    bgcolor: "#fff",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.24)",
                    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#111" },
                    "& .MuiSelect-icon": { color: pink, fontSize: 22 },
                  }}
                >
                  {[10, 25, 50, 100].map((size) => (
                    <MenuItem key={size} value={size}>{size}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Stack direction="row" spacing={2} sx={{ pr: 2.5 }}>
                <IconButton sx={{ color: "#7b7b7b", p: 0.4 }}>
                  <RefreshIcon sx={{ fontSize: 27 }} />
                </IconButton>
                <IconButton sx={{ color: "#7b7b7b", p: 0.4 }}>
                  <FileDownloadOutlinedIcon sx={{ fontSize: 27 }} />
                </IconButton>
              </Stack>
            </Box>

            <TableContainer
              component={Paper}
              elevation={0}
              sx={{
                height: 320,
                maxHeight: 320,
                borderRadius: 0,
                overflowY: "auto",
                "&::-webkit-scrollbar": { width: 10 },
                "&::-webkit-scrollbar-track": { bgcolor: "#eeeeee" },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: "#4f46e5",
                  borderRadius: 10,
                  "&:hover": { bgcolor: "#4338ca" },
                },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth: 980 }}>
                <TableHead>
                  <TableRow>
                    {[
                      { label: "Model", width: "11%" },
                      { label: "apk Command", width: "31%" },
                      { label: "IP Command", width: "30%" },
                      { label: "timezone Command", width: "20%" },
                      { label: "Action", width: "8%" },
                    ].map((head) => (
                      <TableCell
                        key={head.label}
                        sx={{
                          width: head.width,
                          bgcolor: "#f5f6f8",
                          color: "#777",
                          fontSize: 13,
                          fontWeight: 500,
                          borderBottom: "0",
                          py: 1.1,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {head.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visibleRows.map((row) => (
                    <TableRow key={`${row.model}-${row.ipCommand}`}>
                      <TableCell sx={{ ...tableCellSx, fontWeight: 700 }}>{row.model}</TableCell>
                      <TableCell sx={{ ...tableCellSx, fontWeight: 700 }}>{row.apkCommand}</TableCell>
                      <TableCell sx={{ ...tableCellSx, fontWeight: 700 }}>{row.ipCommand}</TableCell>
                      <TableCell sx={{ ...tableCellSx, fontWeight: 700 }}>{row.timezoneCommand}</TableCell>
                      <TableCell sx={tableCellSx} />
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box
              sx={{
                minHeight: 47,
                px: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderTop: "1px solid #e5e7eb",
              }}
            >
              <Typography sx={{ fontSize: 16, color: "#3b3b3b" }}>
                Showing {totalRows ? startIndex + 1 : 0} to {endIndex} of {totalRows} entries
              </Typography>

              <Pagination
                page={page}
                count={totalPages}
                onChange={(_, value) => setPage(value)}
                siblingCount={1}
                boundaryCount={1}
                showFirstButton={false}
                showLastButton={false}
                shape="rounded"
                sx={{
                  "& .MuiPaginationItem-root": {
                    height: 31,
                    minWidth: 32,
                    borderRadius: 0,
                    border: "1px solid #7b7b7b",
                    color: "#111",
                    fontSize: 16,
                    m: 0,
                    bgcolor: "#fff",
                  },
                  "& .Mui-selected": {
                    bgcolor: "#141927 !important",
                    color: "#fff",
                    borderColor: "#141927",
                  },
                }}
              />
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
